var count = 1;
var savedWorkspaceFlag = false;

var menu = $('#nav');
var origOffsetY = menu.offset() ? menu.offset().top : menu.offset();
function searchClick() {
    //$("#searchCriteriaContainer").collapse("toggle");
    //$("#addedFileContainer").addClass("in");
}
//function to fixed navbar
function navbarFixed() {
        if ($(window).scrollTop() >= origOffsetY) {
            $('#nav').addClass('fixed');
            $('.main-container').addClass('menu-padding');
        } else {
            $('#nav').removeClass('fixed');
            $('.main-container').removeClass('menu-padding');
        }
}
//function assign changes to make footer fixed
function stickyFooterchanges() {
    var getFooterHeight = $(".site-footer").outerHeight() +8;
    $(".page-wrap").css("margin-bottom", "-" +getFooterHeight + "px");
}
//function allign search result with selected results
function assignHeightToSelectedResults() {
    if ($(window).width() > 991) {
        var getTableHeight = $("#searchResultsTable").height() - $("#searchResultsTable thead").height();
        var tblHeight = getTableHeight > 424 ? getTableHeight : 424;
        $(".selected-datasets-entry").css("max-height", tblHeight);

    }
}
$(document).ready(function () {
    navbarFixed();
    stickyFooterchanges();
    //clipboard.js IE11 fix
    $.fn.modal.Constructor.prototype.enforceFocus = function () { };
    //intialize clipboard.js
    var clipboard = new Clipboard('.copy-cite-details');
    var clipboardWorkspace = new Clipboard('#copyUrl');

    clipboard.on('success', function (e) {
        $(".cite-action-text").removeClass("hide");
        $(".cite-action-text").text("Copied!");
        e.clearSelection();
    });

    clipboard.on('error', function (e) {
        $(".cite-action-text").removeClass("hide");
        $(".cite-action-text").text("Press Cmd+C to copy");
    });
    clipboardWorkspace.on('success', function (e) {
        $(".copied-url-msg").removeClass("hide");
        $(".copied-url-msg").text("Copied!");
        e.clearSelection();
    });

    clipboardWorkspace.on('error', function (e) {
        $(".copied-url-msg").removeClass("hide");
        $(".copied-url-msg").text("Press Cmd+C to copy");
    });
    ////To avoid scroll in body when modal is open
    //$('body').on('show.bs.modal', ".modal", function () {
    //    if ($(document).height() > $(window).height()) {
    //        // no-scroll
    //        $('body').addClass("modal-open-noscroll");
    //    }
    //    else {
    //        $('body').removeClass("modal-open-noscroll");
    //    }
    //})
    //$('body').on('hide.bs.modal', '.modal', function () {
    //    $('body').removeClass("modal-open-noscroll");
    //})

    //Toggle legends click get height
    $(".swipe-wrap").on('click', '.toggle-legends', function () {
        $(this).find("i").toggleClass("fa-angle-up fa-angle-down");
        if ($(this).find("i").hasClass("fa-angle-up")) {
            $(this).find("i").attr("title", "Collapse");
            $(this).next().slideDown(function () {
                $(".toggle-legends").next().css("height", getLegendHeight);
            });
        } else {
            $(this).find("i").attr("title", "Expand");
            getLegendHeight = $(this).next().css("height");
            $(this).next().slideUp();

        }
    });
    //render chart
    //renderChart2("chartdiv", "legendDivId");
    $("#chartModal").modal("show");
    //renderModalChart("modalChartDiv", "modalLegendDiv");
    $("#chartModal").modal("hide");

    //Hide amcharts text on graph
    $("#chartdiv").find(".amcharts-chart-div a").hide();
    $("#chartModal .modal-body").find(".amcharts-chart-div a").hide();

    $(".table-chart-details").on("click", ".fa-list-alt", function () {
        $("html, body").animate({
            scrollTop: 0
        }, "50");
        $(".expand-graph-icon, .refresh-graph-icon, .share-graph-icon, .save-graph-icon").hide();
        $(".chart-icon").show();
        setTimeout(function () {

            //mySwipe.slide('5');

        }, 200);
    });

    $("#dashboardTabsContainer").on("click", ".fa-times", function () {
        var chartID = $(this).closest(".chart-tab").find("a").attr("href");
        $(this).closest(".chart-tab").remove();
        $(chartID).remove();
        $('a[href="' + "#dashboardTab" + '"]').tab("show");
    });

    //Expnad graph
    $(".expand-graph-icon").on('click', function () {
        $("#chartModal").modal("show");

        setTimeout(function () {
            $("#modalChartDiv").css("min-height", $("#chartModal .modal-content").height() - 150);
            //Hide amcharts text on graph
            $("#chartdiv").find(".amcharts-chart-div a").hide();
            $("#chartModal .modal-body").find(".amcharts-chart-div a").remove();
            if ($(window).width() < 768) {
                //$("#modalLegendDiv").removeClass("in");
            }
        }, 500);
    });
    //plotting area clicked
    $(".plotting-area").on('click', function () {
        if ($(this).hasClass("disabled")) {
            return false;
        }
        //        if($(window).width()<768){
        //            $("#mobileMenuToggle").trigger('click');
        //        }
        //$(".back-icon").show();
        //$(".save-graph-icon").show();
        //$(".share-graph-icon").show();
        //$(".refresh-graph-icon").show();
        //$(".expand-graph-icon").show();
        //$(".chart-icon").hide();
        ////$(".save-workspace-link").parent().removeClass("active");
        ////$(".search-nav-link").parent().removeClass("active");
        //$(this).parent().addClass("active");
        ////mySwipe.slide("1")

    });
    $(".back-icon").on("click", function () {
        $(this).hide();
        $(".save-graph-icon").hide();
        $(".refresh-graph-icon").hide(); $(".expand-graph-icon").hide();
        $(".share-graph-icon").hide();
        //$("#showchart").css("margin","0 20px");
        $("#searchUploadChemicals").removeClass("no-box-shadow");
        $(".chart-icon").hide();
        //nav bar class
        //$(".plotting-area").parent().removeClass("active");
        //$(".save-workspace-link").parent().removeClass("active");
        //$(".search-nav-link").parent().addClass("active");
    });
    $(".back-arrow-icon").on("click", function () {
        $(".save-graph-icon").hide();
        $(".refresh-graph-icon").hide(); $(".expand-graph-icon").hide();
        $(".share-graph-icon").hide();
        //$("#showchart").css("margin","0 20px");
        $("#searchUploadChemicals").removeClass("no-box-shadow");
        $(".chart-icon").hide();
        //nav bar class
        //$(".save-workspace-link").parent().removeClass("active");
        //$(".search-nav-link").parent().addClass("active");
        //mySwipe.slide("0");
    });
    //var elem = document.getElementById('mySwipe');
    //window.mySwipe = Swipe(elem, {
    //    // startSlide: 4,
    //    // auto: 3000,
    //    continuous: false,
    //    disableTouch: true
    //    // stopPropagation: true,
    //    // callback: function(index, element) {},
    //    // transitionEnd: function(index, element) {}
    //});
    //$(".add-search-result").on('click', function () {
    //    $("#addedChemicals tbody").children().remove();
    //    $("#searchResultsTable input[type=checkbox]").each(function () {
    //        addTr = '<td>Aluminium Sulphate - Al2SO4 - Simon Trainor - survey - 350 - 2500</td>';
    //        if ($(this).prop("checked") == true) {
    //            $(this).closest("td").addClass("hide-in");
    //            $("#addedFileContainer").show();
    //            $(".no-chemical-msg").hide();
    //            $("#addedFileContainer").css("left", "0");
    //            $(".plot-chart").removeClass("disabled");
    //            $(".plot-chart").prop("disabled", false);
    //            var newRow = '<tr>' + addTr + '<td><a href="#"><i class="fa remove-dataset fa-trash-o pull-right fa-1-5x"></i></a></td></tr>';
    //            $("#addedChemicals tbody").append(newRow);
    //            //For tablet view scroll to that position
    //            if ($(window).width() < 992) {
    //                $("html, body").animate({
    //                    scrollTop: $("#addedFileContainer").offset().top
    //                }, "slow");
    //            }

    //        }
    //    });
    //});
    $(".input-offset").on('focus', function () {
        $(this).siblings().find("input[type='checkbox']").removeClass("disabled");
        $(this).siblings().find("input[type='checkbox']").prop("disabled", false);
    });
    //$(".input-feild-textbox").on("focusin", function () {
    //    $(this).siblings("label").addClass("active");
    //}).focusout(function () {
    //    if (!$(this).val()) {
    //        $(this).siblings("label").removeClass("active");
    //    }
    //});
    /*$(".input-feild-textbox").on("focusout",function(){
        
    });*/
    //when clicked on add icon to add chemical
    //    $(".add-chemical").on("click", function () {
    //        if (!($(this).hasClass("remove-chemical"))) {
    //            var chemProp = [];
    //            var createString = "";
    //            //enable plot btn
    //            $(".plot-chart").removeClass("disabled");
    //            $(".plot-chart").prop("disabled", false);
    //            $(".no-chemical-msg").hide();
    //            $(".added-chemicals-title").removeClass("title-border-bottom");
    //            //assign id equivalent to row which will be added in table
    //            $(this).attr("id", count);
    //            count += 1;
    //            $(this).toggleClass("fa-plus fa-minus");
    //            $(this).addClass("remove-chemical");
    //            $(this).addClass("color-red");
    //            $(this).attr("title", "Remove");

    //            if($(window).width()>767){
    //                var getParentId = $(this).closest("tr").attr("id");
    //                $("#" + getParentId).addClass("added-row");
    //                $("#" + getParentId).next().addClass("added-row");
    //                $("#" + getParentId + " td.hidden-xs").each(function () {
    //                    if (!($(this).children().hasClass("fa-minus") || $(this).children().hasClass("toggle-row-element"))) {
    //                        chemProp.push($(this).text());
    //                    }
    //                }); 
    //            } else {
    //                var getParentId = $(this).closest("table").parents("tr").attr("id");
    //                var getTable=$("#" + getParentId).find(".xs-tbody").attr("id");
    //                $("#" + getParentId).find(".xs-tbody").addClass("added-row")
    //                 $("#" + getTable + " td.xs-text-td").each(function () {
    //                    chemProp.push($(this).text());
    //                });
    //            }
    //            var i;
    //            for (i = 0; i < chemProp.length; i++) {

    //                var j = i + 1;
    //                if (j == chemProp.length) {
    //                    createString += chemProp[i];
    //                } else {
    //                    createString += chemProp[i].replace(/\s/g, '-') + ' - ';
    //                }

    //            }
    //            //Add string to the added chemicals table
    //            var newRow = '<tr id="addedChemicalProp-' + getParentId + '" class="added-row" style="display:none;"><td>' + createString + '</td><td><i class="fa fa-trash-o remove-dataset pull-right fa-1-5x" title="Remove"></i></td></tr>';
    //            $("#addedChemicals tbody").append(newRow);
    //            $("#addedChemicals tbody").find("#addedChemicalProp-" + getParentId).fadeIn(function () {
    //                $("#addedChemicals tbody").find("#addedChemicalProp-" + getParentId).removeClass("added-row");
    //            });

    //            //For tablet view scroll to that position
    ////            if ($(window).width() < 992) {
    ////                $("html, body").animate({
    ////                    scrollTop: $(".selected-datasets-sm").offset().top
    ////                }, "slow");
    ////            }
    //        } else {
    //            if($(window).width()>768){
    //                var getParentId = $(this).closest("tr").attr("id");
    //                $("#" + getParentId).removeClass("added-row");
    //                $("#" + getParentId).next().removeClass("added-row");
    //            } else {
    //            var getParentId = $(this).closest("table").parents("tr").attr("id");
    //            $("#" + getParentId).find(".xs-tbody").removeClass("added-row")
    //            }

    //            $(this).toggleClass("fa-plus fa-minus");
    //            $(this).removeClass("remove-chemical");
    //            $(this).removeClass("color-red");
    //            $(this).attr("title", "Add");
    //            $("#addedChemicals").find("#addedChemicalProp-" + getParentId).fadeOut('fast', function () {
    //                $("#addedChemicals").find("#addedChemicalProp-" + getParentId).remove();
    //            });
    //            //if the last chemical is removed
    //            if ($("#addedChemicals tbody").children().length == 1) {
    //                $(".plot-chart").addClass("disabled");
    //                $(".plot-chart").prop("disabled", true);
    //                $(".no-chemical-msg").fadeIn();
    //                $(".added-chemicals-title").addClass("title-border-bottom");
    //            }
    //        }
    //    });
    //remove chemical when click on remove icon

    //Save workspace link click
    //$(".save-workspace-link").on('click', function () {
    //    //        if($(window).width()<768){
    //    //            $("#mobileMenuToggle").trigger('click');
    //    //        }
    //    $(this).parent().siblings().removeClass("active");
    //    $(this).parent().addClass("active");
    //    $(".back-icon").show();
    //    $(".save-graph-icon").hide();
    //    $(".refresh-graph-icon").hide(); $(".expand-graph-icon").hide();
    //    $(".share-graph-icon").hide();
    //    $(".refresh-graph-icon").hide();

    //    //mySwipe.slide("3")
    //});
    $(".save-arrow-workspace").on('click', function () {
        $(".back-icon").show();
        $(".save-graph-icon").hide();
        $(".refresh-graph-icon").hide(); $(".expand-graph-icon").hide();
        $(".share-graph-icon").hide();
        $(".refresh-graph-icon").hide();

        //mySwipe.slide("3")
    });
    $("#saveGraphBtn").on('click', function () {
        var graphName = $("#graphName").val();
        var graphChemicals = "Si (100), Al2O3, Kovar sheet";
        var newGraphToSave = '<tr class="added-row newRow"><td>' + graphName + '</td><td>' + graphChemicals + '</td><td><i class="fa fa-trash-o pull-right fa-1-5x"></i><i title="Share graph" class="fa fa-share-alt-square pull-right fa-1-5x mrR-5"></i></td></tr>'
        $("#SavedGraphTable").prepend(newGraphToSave);
        setTimeout(function () {
            $("#SavedGraphTable").find(".newRow").removeClass("added-row");
            //mySwipe.slide("1");
            $(".share-graph-icon").show();
            $(".save-graph-icon").show();
            $(".refresh-graph-icon").show(); $(".expand-graph-icon").show();
            $(".chart-icon").hide();
        }, 1000);
        $("#graphName , #graphOwner").attr("disabled", "disabled");
        $("#cancelSaveBtn , #saveGraphBtn").attr("disabled", "disabled");
    });

    $("#cancelSaveBtn").on('click', function () {
        $(".save-graph-icon").show();
        $(".share-graph-icon").show();
        $(".refresh-graph-icon").show(); $(".expand-graph-icon").show();
        $(".chart-icon").hide();
        //mySwipe.prev();
    });
    $(".save-graph-icon").on('click', function () {
        $("#graphName , #graphOwner").removeAttr("disabled");
        $("#cancelSaveBtn , #saveGraphBtn").removeAttr("disabled");
        $("#graphName").val('');
        $("#graphOwner").val('');
        $(".share-graph-icon ,.save-graph-icon,.refresh-graph-icon,.expand-graph-icon").hide();
        $(".chart-icon").show();
        //mySwipe.slide("2");
    });
    $(".share-graph-icon").on('click', function () {
        $(".share-graph-icon ,.save-graph-icon ,.refresh-graph-icon,.expand-graph-icon ").hide();
        $(".chart-icon").show();
        //mySwipe.slide("4");
    });
    $(".cancel-share-btn").on('click', function () {
        $(".save-graph-icon").show();
        $(".share-graph-icon").show();
        $(".refresh-graph-icon").show();
        $(".expand-graph-icon").show();
        $(".chart-icon").hide();
        //mySwipe.slide("1");
    });
    $("#sendEmail").on('click', function () {
        $(".email-sent-msg").show();
        setTimeout(function () {
            $(".email-sent-msg").hide();
            //mySwipe.slide("1");
            $(".save-graph-icon").show();
            $(".share-graph-icon").show();
            $(".refresh-graph-icon").show();
            $(".expand-graph-icon").show();
            $(".chart-icon").hide();
            $("#emailIdToShare").val("");
            $("#emailIdToShare").focusout();
        }, 1000);
    });
    $(".chart-icon").on("click", function () {
        $(".share-graph-icon ,.save-graph-icon, .back-icon").show();
        $(".refresh-graph-icon").show();
        $(".expand-graph-icon").show();
        $(".chart-icon").hide();
    });
    //when clicked on saved workspace link
    $(".saved-workspace-link").on('click', function () {
        //mySwipe.slide("1");
        savedWorkspaceFlag = true;
        $("#searchResultsTable tbody").find(".added-row").removeClass("added-row");
        $("#searchResultsTable .remove-chemical").each(function () {
            $(this).removeClass("color-red");
            $(this).removeClass("remove-chemical").addClass("add-chemical");
            $(this).removeClass("fa-minus").addClass("fa-plus");

        });
        $("#searchResultsContainer").removeClass("in");
        $(".no-dataset-msg").show();
        $(".no-chemical-msg").hide();
        $(".chart-icon").hide();
        $(".save-graph-icon").show();
        $(".share-graph-icon").show();
        $(".search-result-div").css("min-height", $(".selected-datasets-div").height());
        $("#addedChemicals tbody").children().remove();
        var newRows = '<tr id="" class=""><td>Silica - Si - survey - 100 - 2500</td><td><i class="fa fa-trash-o pull-right fa-1-5x remove-saved-datasets" title="Remove"></i></td></tr>' +
            '<tr id="" class=""><td>Aluminium-Oxide - Al2O3 - thin film - survey - 350 - 2500</td><td><i class="fa fa-trash-o pull-right fa-1-5x remove-saved-datasets" title="Remove"></i></td></tr>' +
            '<tr id="" class=""><td>Kovar sheet 700C treatment - survey - 350 - 2500</td><td><i class="fa fa-trash-o pull-right fa-1-5x remove-saved-datasets" title="Remove"></i></td></tr>';
        $("#addedChemicals tbody").append(newRows);
        $(".selected-datasets-title").text("Si (100), Kovar Sheet, Al2O3");
    });
    //remove saved workspaces datasets from searh page added datasets
    $("#addedChemicals").on('click', ".remove-saved-datasets", function () {
        $(this).closest("tr").remove();
    });

    //search nav link
    $(".search-nav-link").on('click', function () {
        //        if($(window).width()<768){
        //            $("#mobileMenuToggle").trigger('click');
        //        }
        $(".back-icon").hide();
        $(".share-graph-icon").hide();
        $(".save-graph-icon").hide();
        $(".refresh-graph-icon").hide();
        $(".expand-graph-icon").hide();
        $(".share-graph-icon").hide();
        $(".save-workspace-link").parent().removeClass("active");
        //$(".plotting-area").parent().removeClass("active").addClass("disabled");
        $(".search-nav-link").parent().addClass("active");
        //$(".plotting-area").addClass("disabled").attr("disabled", true);
        //mySwipe.slide('0');
    });

    //remove chart chemical
    //$(".remove-charts-chemical").on('click', function () {
    //    $(this).toggleClass("fa-times fa-check");
    //    $(this).toggleClass("color-red color-green");
    //    if ($(this).hasClass("fa-times")) {
    //        $(this).attr("title", "Remove chemical");
    //    } else {
    //        $(this).attr("title", "Add chemical");
    //    }
    //});

    //Portrait mode
    $(".exit-message").on('click', function () {
        //$("#portraiteMode").remove();
        $("#portraiteMode").modal('hide');
        $(body).css("padding", 0)

    });
    var flag = 0;

    $(window).on("orientationchange", function (event) {
        setTimeout(function () {

            if (window.innerHeight > window.innerWidth && $("#dontShowMessage").prop("checked") != true) {
                //alert("Please use Landscape!");
                $("#portraiteMode").modal('show');
            } else {
                $("#portraiteMode").modal('hide');
            }
        }, 500);

        //alert("This device is in " + OrientationVal + " mode!" );
        //$("#portraiteMode").modal();

    });

    if (window.innerHeight > window.innerWidth && $("#dontShowMessage").prop("checked") != true) {
        if (flag == 0) {
            //alert("Please use Landscape!");
            if ($(window).width() < 767) {
                $("#portraiteMode").modal('show');
                //flag=flag+1;
            }
        }
    }
    ////Requery search results
    //$(".requery-search").on('click',function(){
    //    //make search link as active
    //    $(".save-workspace-link").parent().removeClass("active");
    //    $(".plotting-area").parent().removeClass("active");
    //    $(".search-nav-link").parent().addClass("active");

    //    $(".save-graph-icon").hide();
    //    $(".refresh-graph-icon").hide();
    //    $(".expand-graph-icon").hide();
    //    $(".share-graph-icon").hide();
    //    $(".back-icon").hide();
    //    //mySwipe.slide('0');
    //    //Add vales to text-feild
    //    $("#collapseOne .control-label").addClass("active");
    //    $("#Keywords").val("Al");
    //    $("#chemicalName").val("Aluminium Sulphate");
    //    $("#hostMaterial").val("Al2SO4");
    //    $("#Author").val("Simon");
    //    $("#Region").val("survey");
    //    $("#startValues").val("350");
    //    $("#endValues").val("2500");
    //    //Add chemicals in the selected datasets table
    //    $("#addedChemicals tbody").children().remove();
    //    var newRows = '<tr id="" class=""><td>Silica - Si - survey - 100 - 2500</td><td><i class="fa fa-trash-o pull-right fa-1-5x remove-saved-datasets" title="Remove"></i></td></tr>' +
    //        '<tr id="" class=""><td>Aluminium-Oxide - Al2O3 - thin film - survey - 350 - 2500</td><td><i class="fa fa-trash-o pull-right fa-1-5x remove-saved-datasets" title="Remove"></i></td></tr>' +
    //        '<tr id="" class=""><td>Kovar sheet 700C treatment - survey - 350 - 2500</td><td><i class="fa fa-trash-o pull-right fa-1-5x remove-saved-datasets" title="Remove"></i></td></tr>';
    //    $("#addedChemicals tbody").append(newRows);

    //    //show only one selected in a selected table
    //    var getLength=$("#searchResultsTable .remove-chemical").length;
    //    $("#searchResultsTable .remove-chemical").each(function () {
    //        getLength-=1;
    //        if(!(getLength==1)){
    //            $(this).closest("tr").removeClass("added-row");
    //            $(this).removeClass("color-red");
    //            $(this).removeClass("remove-chemical").addClass("add-chemical");
    //            $(this).removeClass("fa-minus").addClass("fa-plus");
    //        }

    //    });
    //});


    //bact top navigation

    // hide #back-top first
    $("#back-top").hide();

    // fade in #back-top
    $(function () {
        $(window).scroll(function () {
            navbarFixed();
            if ($(this).scrollTop() > 100) {
                $('#back-top').fadeIn();
            } else {
                $('#back-top').fadeOut();
            }
        });
        // scroll body to 0px on click
        $('#back-top a').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 300);
            return false;
        });
    });
    //Toggle row
    $(".swipe-wrap").on('click', ".toggle-savedworkspace-element", function (e) {
        e.preventDefault();
        //$(this).toggleClass("fa-chevron-down fa-chevron-up");
        if ($(this).attr("title") == "View Selected Datasets") {
            $(this).attr("title", "Hide Selected Datasets");
        } else {
            $(this).attr("title", "View Selected Datasets");
        }
        $(this).find("i").toggleClass("fa-angle-up fa-angle-down");
        $(this).closest("tr").next().fadeToggle('slow');
    });

    $(".swipe-wrap").on('click', ".toggle-sharedworkspace-element", function (e) {
        e.preventDefault();
        //$(this).toggleClass("fa-chevron-down fa-chevron-up");
        if ($(this).attr("title") == "View Selected Datasets") {
            $(this).attr("title", "Hide Selected Datasets");
        } else {
            $(this).attr("title", "View Selected Datasets");
        }
        $(this).find("i").toggleClass("fa-angle-up fa-angle-down");
        $(this).closest("tr").next().fadeToggle('slow');
    });

    $(".swipe-wrap").on('click', ".toggle-userLastLogin-details", function (e) {
        e.preventDefault();

        if ($(this).attr("title") == "View User Details") {
            $(this).attr("title", "Hide User Details");
        } else {
            $(this).attr("title", "View User Details");
        }
        $(this).closest("tr").next().fadeToggle('slow');
    });

    //Toggle row
    $("#searchResultsTable").on('click', ".toggle-row-element", function (e) {
        e.preventDefault();
        //$(this).toggleClass("fa-chevron-down fa-chevron-up");
        if ($(this).attr("title") == "Expand") {
            $(this).attr("title", "Collapse");
        } else {
            $(this).attr("title", "Expand");
        }
        $(this).toggleClass("fa-angle-up fa-angle-down");
        $(this).closest("tr").next().fadeToggle('slow');
    });
    //Toggle all row element
    $(".toggle-all-row-element").on('click', function (e) {
        e.preventDefault();
        //$(this).toggleClass("fa-chevron-down fa-chevron-up");
        if ($(this).hasClass("fa-angle-double-down")) {
            //$(".toggle-row-element").fadeIn("slow");
            $(".toggle-row-element").removeClass("fa-angle-down").addClass("fa-angle-up");
            $(".toggle-row-element").attr("title", "Collapse");
            $(this).attr("title", "Collapse all");
            $(this).addClass("fa-angle-double-up").removeClass("fa-angle-double-down");
            $(".collapsable-table-tr").fadeIn('slow');
        } else {
            //$(".toggle-row-element").fadeOut("slow");
            $(".toggle-row-element").removeClass("fa-angle-up").addClass("fa-angle-down");
            $(".toggle-row-element").attr("title", "Expand");
            $(this).attr("title", "Expand all");
            $(this).removeClass("fa-angle-double-up").addClass("fa-angle-double-down");
            $(".collapsable-table-tr").fadeOut('slow');
        }

    });

    //When click on figures radio button
    $(".graph-figures input[type=radio]").on('click', function () {
        var getAttr = $(this).attr("graph-figures");
        //checked the other radio button in modal
        $(".modal-graph-figures input[type=radio]").each(function () {
            if ($(this).attr("graph-figures") == getAttr) {
                $(this).prop("checked", true);
            } else {
                $(this).prop("checked", false);
            }
        });
        //renderChart2('chartdiv', 'legendDivId');
        //renderModalChart("modalChartDiv", "modalLegendDiv");

    });
    $(".modal-graph-figures input[type=radio]").on('click', function () {
        var getAttr = $(this).attr("graph-figures");
        //checked the other radio button in modal
        $(".graph-figures input[type=radio]").each(function () {
            if ($(this).attr("graph-figures") == getAttr) {
                $(this).prop("checked", true);
            } else {
                $(this).prop("checked", false);
            }
        });
        //renderChart2('chartdiv', 'legendDivId');
        //renderModalChart("modalChartDiv", "modalLegendDiv");

    });
    function handleDivHeight() {
        //var getActiveDivPos = //mySwipe.getPos();
        //$(".swipe-wrap").children().each(function () {
        //    if ($(this).attr("data-index") == getActiveDivPos) {
        //        $(".swipe-wrap").css("height", $(this).outerHeight())
        //    }
        //});
    }
    $(document).on('click', function () {
        if ($(window).width() < 768) {
            handleDivHeight();
        }
    })
    assignViewportHeightChart();

    var clipboard = new Clipboard('.copyurl-btn', {
        target: function () {
            return document.getElementById('copyurl');
        }
    });

    function updateTablesGraphId() {
        var graphId = 0;
        if ($(window).width() > 768) {
            $(".table-chart-details .lg-tr").each(function () {
                $(this).attr("id", "graph-row-" + graphId);
                $(this).find(".show-hide-graph").attr("graph-id", graphId);
                $(this).find(".remove-charts-chemical").attr("graph-id", graphId);
                graphId += 1;
            })

        }

    }
    //remove chart chemical
    $(".remove-charts-chemical").on('click', function () {
        var getGraphNo = parseInt($(this).attr("graph-id"));
        var chart1 = chart.graphs[getGraphNo].chart;
        chart1.removeGraph(chart.graphs[getGraphNo]);
        var chart22 = modalChart.graphs[getGraphNo].chart;
        chart22.removeGraph(modalChart.graphs[getGraphNo]);
        $(this).closest("tr").addClass("remove-graph-tr");
        if ($(window).width() > 768) {
            $(this).closest("tr").fadeIn("slow", function () {
                $(this).closest("tr").remove();
            });
        } else {
            $(this).closest("table").remove()
        }
        updateTablesGraphId();
    });
    $(".remove-all-graph").on('click', function () {
        var noOFGraph = chart.graphs.length;
        var j = noOFGraph;
        var i = 0;
        for (i = 0; i < noOFGraph; i++) {
            j -= 1;
            var chart1 = chart.graphs[j].chart;
            chart1.removeGraph(chart.graphs[j]);
            var chart22 = modalChart.graphs[j].chart;
            chart22.removeGraph(modalChart.graphs[j]);
        }
        $(".table-chart-details tbody").children().remove();
        $(".hide-show-allgraphs").hide();
        $(this).hide();
    });
    
    //hide show all graphs
    $(".hide-show-allgraphs").on('click', function () {
        if ($(this).hasClass("all-hiddden")) {
            $(this).removeClass("all-hiddden");
            $(this).text("Hide all graphs");
            $(this).attr("title", "Uncheck to hide all graphs");
            var i = 0;
            for (i = 0; i < chart.graphs.length; i++) {
                var chart1 = chart.graphs[i].chart;
                chart1.showGraph(chart.graphs[i]);

                var chart22 = modalChart.graphs[i].chart;
                chart22.showGraph(modalChart.graphs[i]);
            }
            //change change eye icon in table
            $(".show-hide-graph").each(function () {
                $(this).removeClass("fa-eye-slash").addClass("fa-eye");
                $(this).attr("title", "Hide graph");
            });
        } else {
            $(this).addClass("all-hiddden");
            $(this).text("Show all graphs");
            $(this).attr("title", "Check to show all graphs");
            var i = 0;
            for (i = 0; i < chart.graphs.length; i++) {
                var chart1 = chart.graphs[i].chart;
                chart1.hideGraph(chart.graphs[i]);

                var chart22 = modalChart.graphs[i].chart;
                chart22.hideGraph(modalChart.graphs[i]);
            }
            //change change eye icon in table
            $(".show-hide-graph").each(function () {
                $(this).removeClass("fa-eye").addClass("fa-eye-slash");
                $(this).attr("title", "Show graph");
            });

        }
        //Hide amcharts text on graph
        $("#chartdiv").find(".amcharts-chart-div a").hide();
        $("#chartModal .modal-body").find(".amcharts-chart-div a").hide();
    });

    //$(".offset-toggle").on('click', function () {
    //    $(this).toggleClass("fa-toggle-on fa-toggle-off");
    //    $(this).parent().find(".offset-input").toggleClass("input-active");
    //});
    //Left menu push function
    var showLeftPush = document.getElementById('mobileMenuToggle'),
        menuLeft = document.getElementById('cbp-spmenu-s2'),
        body = document.body;
    if (showLeftPush) {
        showLeftPush.onclick = function () {
            //if (!$(this).hasClass("active")){
            classie.toggle(this, 'active');
            classie.toggle(body, 'cbp-spmenu-push-toleft');
            classie.toggle(menuLeft, 'cbp-spmenu-open');
            if ($('body').hasClass("cbp-spmenu-push-toleft")) {
                $("#nav").addClass("cbp-spmenu-push-toleft");
            } else {
                $("#nav").removeClass("cbp-spmenu-push-toleft");
            }
        };
    }
    //function to hide menu when click outside
    function CloseMobileMenu(e) {
        var containerResource = $("#cbp-spmenu-s2");
        var btnTohideMenu = $("#mobileMenuToggle");
        var navLi = $(".right-mobile-menu li");
        if (!containerResource.is(e.target) && containerResource.hasClass('cbp-spmenu-open') && !btnTohideMenu.is(e.target) && !navLi.is(e.target)) {
            $("#mobileMenuToggle").trigger('click');
        }

    }
    $(document).on('click', function (e) {
        CloseMobileMenu(e);
    });
    $(document).ready(function () {
        //generateYear();
        //function generateYear() {
        //    var i, yr, now = new Date();
        //    for (i = 10; i >= 1; i--) {
        //        yr = now.getFullYear() - i; // or whatever
        //        $('.year-dropdown').prepend('<li year="year-' + i + '"><a>' + yr + '</a></li>');

        //    };
        //    $('.year-dropdown').prepend('<li year="year-' + i + '"><a>' + now.getFullYear() + '</a></li>');
        //}
        function reduceChartWidth() {
            for (var i = 0; i < AmCharts.charts.length; i++) {
                var chart = AmCharts.charts[i];
                chart.div.style.width = "1000px";
                chart.validateNow();
            }
        }
        function assignDefaultWidthToChart() {
            for (var i = 0; i < AmCharts.charts.length; i++) {
                var chart = AmCharts.charts[i];
                chart.div.style.width = "100%";
                chart.validateNow();
            }
        }
        $(".swipe-wrap").on('click', ".print-icon", function () {
            //change the dimension of chart div
            var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            reduceChartWidth();
            var contents = $("#showchart").html();
            var frame1 = $('<iframe />');
            frame1[0].name = "frame1";
            frame1.css({
                "position": "absolute",
                "top": "-1000000px"
            });
            $("body").append(frame1);
            var frameDoc = frame1[0].contentWindow; //? frame1[0].contentWindow : frame1[0].contentDocument.document ? frame1[0].contentDocument.document : frame1[0].contentDocument;
            frameDoc.document.open();
            //Create a new HTML document.
            frameDoc.document.write('<html><head>');
            frameDoc.document.write('</head><body>');
            //Append the external CSS file.
            frameDoc.document.write('<link href="assets/css/style.css" rel="stylesheet" type="text/css" />');
            frameDoc.document.write('<link href="assets/css/index.css" rel="stylesheet" type="text/css" />');
            frameDoc.document.write('<link href="assets/css/custom.css" rel="stylesheet" type="text/css" />');
            frameDoc.document.write('<link href="assets/css/print.css" rel="stylesheet" type="text/css" />');
            //frameDoc.document.write('<link href="assets/bootstrap.min.css" rel="stylesheet" type="text/css" />');
            //Append the DIV contents.
            frameDoc.document.write(contents);
            frameDoc.document.write('</body></html>');
            frameDoc.document.close();
            if (isFirefox) {
                window.frame1.focus();
                window.frame1.print();
                assignDefaultWidthToChart();
            } else {
                setTimeout(function () {
                    //alert("Hello");
                    window.frame1.focus();
                    window.frame1.print();
                    assignDefaultWidthToChart();
                }, 500);
            }

            setTimeout(function () {
                frame1.remove();
            }, 2000)

        });
    });
});
$(window).resize(function () {
    //Assign height to chart in mobile when orientation changes
    assignViewportHeightChart();
    stickyFooterchanges();
    assignHeightToSelectedResults();
})

function assignViewportHeightChart() {
    if ($(window).width() < 768) {
        if (window.innerHeight < window.innerWidth) {
            $("#chartdiv").css("height", $(window).height());
            $("#modalChartDiv").css("height", $(window).height());
        } else {
            $("#chartdiv").css("height", "500px");
            $("#modalChartDiv").css("height", "500px");
        }
    }
}

//$(".swipe-wrap").on('click', ".offset-toggle", function () {
//    //var spectrumID = $(this).attr("spectrum-id");
//    var getRow = $(this).closest("tr").attr("row");
//    $(".print-visible").find("." + getRow).find(".offset-toggle").toggleClass("fa-toggle-on fa-toggle-off");
//    $(this).toggleClass("fa-toggle-on fa-toggle-off");
//    if ($(this).hasClass("fa-toggle-on")) {
        
//    } else {
//        //$("#customLegends").find("[toggle='" + getRow + "']").hide();
//    }
//    $(this).parent().find(".offset-input").toggleClass("input-active");

    
//});

//window.onunload = function () {
//    var institute = readCookie('institute');
//    if (institute!=undefined) {
//        delete_cookie('institute');
//        delete_cookie('TokenInfo');
//        delete_cookie('IsAuthenticated');
//        delete_cookie('userName');
//        delete_cookie('fullName');
//    }
//    return '';
//};

//function delete_cookie(name) {
//    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
//}

//function readCookie(name) {
//    var nameEQ = name + "=";
//    var ca = document.cookie.split(';');
//    for (var i = 0; i < ca.length; i++) {
//        var c = ca[i];
//        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
//        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//    }
//    return null;
//}
